import { render, staticRenderFns } from "./Svenja.vue?vue&type=template&id=314b62ca&scoped=true&"
import script from "./Svenja.vue?vue&type=script&lang=js&"
export * from "./Svenja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b62ca",
  null
  
)

export default component.exports